// 分析対象にする操作回数
export const ANALYZE_OPERATION_COUNT_MIN = 1;     // より少ない操作回数は除外する。
export const ANALYZE_OPERATION_COUNT_MAX = 4500;  // より多い操作回数は除外する。

// 操作回数ヒートマップ用
export const HEATMAP_OP_COUNT_DEFAULT_MAX = 10000;  // ヒートマップ表示上の操作回数上限デフォルト値
